<template>
  <div class="flex-1 flex flex-col overflow-hidden mb-16">
    <loading :active="releaseType"
              :can-cancel="true"
              :on-cancel="onCancel"
              :is-full-page="true"
              :color="'#fff'"
              :background-color="'#000'"
              :opacity="'0.8'"
              :loader=" dots"
              :style="style">
              <!-- <div class="text-center text-blue-50 text-4xl" style="background-color:red;word-wrap:break-word; width:300px;">建立關鍵字...</div>
              <div class="w-2/4" style="background-color:blue;display: flex; justify-content: center; align-items: center; width:300px; ">
                <div style="margin: auto"> -->
                  <!-- <circle-progress :percent="releasePercent" :show-percent="true" :class="'text-blue-50 text-4xl'"/> -->
                  <div id="myItem5" class="ldBar label-center" data-type="fill" data-img="https://dev-private.autoturn.net/autoturn_logo_v04.svg" style="width:300px;height:300px;" ></div>
                <!-- </div>
              </div> -->
    </loading>
    <loading :active="!showCampaignData"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="true"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <Header :title="showLang[selectLang]['views']['EventBrowse']['page_name']" @childLang="useLang">
      <div class="mx-4 text-gray-700">
        {{showLang[selectLang]['views']['EventBrowse']['advertising_source']}}
      </div>
      <div class="grid grid-cols-4 border-2 rounded-md w-28 -ml-2" style="border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);">
        <img class="mt-0.5 ml-0.5" width="25" src="https://dev-private.autoturn.net/img/tiktok_icon.png"/>
        <div class="mx-1 text-sm leading-7">
          Tiktok
        </div>
      </div>
      <div class="mx-4 text-gray-700">
        {{showLang[selectLang]['views']['EventBrowse']['advertise_account_text']}}
      </div>
      <div class="mx-1 text-sm text-gray-400 leading-7 border-2 rounded-md px-1 -ml-2" style="border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);">
        {{ adaccount_name }}
      </div>
    </Header>
    <main class="flex overflow-x-hidden bg-gray-200">
      <div class="w-1/5 mx-auto p-4">
        <div class="w-full rounded-xl bg-white p-4" :style="{height: `520px`}">
          <div v-show="false" class="h-16">
            <span class="break-all">{{campaign_name}}</span>
          </div>
          <hr v-show="false" class="mb-4 border-b-1 border-blueGray-200">
          <div class="space-y-4 overflow-y-auto" :style="{height: `480px`}">
            <div v-for="(item, index) in menu" :key="index">
              <div
                v-if="item.show"
                @click="getHere(item.target)"
                :class="[
                  item.open? 'text-gray-700 p-1 cursor-pointer h-8 -mb-6' : 'text-gray-300',
                  item.target === target? 'bg-gray-100 rounded-xl' : ''
                ]">
                <!-- <i class="pi pi-chevron-down"></i> -->
                <i class="pi pi-chevron-down block float-left mt-1.5"></i>
                <!-- <span class="mx-2">{{ item.title }}</span> -->
                <span class="mx-2 block float-left w-36 break-words">{{ item.title }}</span>
                <i class="pi pi-lock float-right" v-if="!item.open"></i>
              </div>
              <div class="space-y-2 ml-4 my-2 mt-7" v-if="item.open">
                <div
                  class="text-gray-700 cursor-pointer ml-1"
                  @click="getHere(item.target)"
                  v-for="(sub, idx) in item.submenu" :key="idx">
                  <span v-if="sub.show" class="mx-2 block w-40 break-words">{{ sub.title }}</span>
                  <i class="pi pi-check-circle float-right" v-if="sub.checked"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="edit_content" ref="scrollcontent" class="w-4/5 mx-auto p-4 overflow-y-auto">
        <div v-show="target == 1">
          <CampaignName v-bind:editPage="cancelEdit" v-model:viewDatalist="campaign_name" v-bind:lang="showLang[selectLang]" />
          <MarketingMethod v-bind:editPage="cancelEdit" v-model:viewDatalist="methodData" v-bind:goalsObjective="getGoalsObjective" v-bind:currencyList="currencyData" v-bind:lang="showLang[selectLang]" @childTargetKW="methodTargetKW" @childTargetDM="methodTargetDM" @childTargetLA="methodTargetLA" @childTargetAD="methodTargetAD" />
          <KeywordMix v-bind:editPage="cancelEdit" v-bind:targetKW="showTargetKW" v-bind:viewDatalist="keywordData" v-bind:lang="showLang[selectLang]" />
          <AdvertisingMix v-if="false" v-bind:showAdvertisingMix="showAdvertisingMix" v-bind:editPage="cancelEdit" v-bind:viewDatalist="lookData" v-bind:lang="showLang[selectLang]" />
          <ConfidentialAudience v-if="false" v-bind:showMarketingDate="showMarketingDate" v-bind:editPage="cancelEdit" v-bind:viewDatalist="dateData" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" />
          <MarketingDate v-bind:showMarketingDate="showMarketingDate" v-bind:editPage="cancelEdit" v-bind:viewDatalist="dateData" v-bind:lang="showLang[selectLang]" v-bind:efficientAi="efficientAi" />
        </div>
        <!-- <div v-show="target == 2">
          <KeywordMix v-if="showTargetKW || showTargetLA" v-bind:editPage="cancelEdit" v-bind:targetKW="showTargetKW" v-bind:viewDatalist="keywordData" />
          <AdvertisingMix v-if="showTargetLA" v-bind:showAdvertisingMix="showAdvertisingMix" v-bind:editPage="cancelEdit" v-bind:viewDatalist="lookData" />
        </div> -->
        <div v-show="target == 2">
          <GoalsAndBudget v-bind:showGoalsAndBudget="showGoalsAndBudget" v-bind:editPage="cancelEdit" v-bind:viewDatalist="goalsData" v-bind:dbRiskLevelCode="dbRiskLevelCode" v-bind:getDate="returnGapTime" v-bind:budgetKWTotal="budgetKW" v-bind:useEndDate="returnUseEndDate" v-bind:formMinAddition="updateMinAddition" v-bind:currencyList="currencyData" v-bind:lang="showLang[selectLang]" v-bind:useLang="selectLang" v-bind:efficientAi="efficientAi" @childObjective="goalsObjective"/>
          <Regions v-bind:editPage="cancelEdit" v-bind:viewDatalist="regionsData" v-bind:targetDM="showTargetDM" v-model:selectCountries="selectCountries" v-model:selectLangs="selectLangs" v-bind:lang="showLang[selectLang]" />
          <Relationship v-bind:showRelationship="showRelationship" v-bind:editPage="cancelEdit" v-bind:viewDatalist="exAudiencesData" v-bind:lang="showLang[selectLang]" v-bind:efficientAi="efficientAi" />
        </div>
        <div v-show="target == 3">
          <PositionAndDevice v-bind:editPage="cancelEdit" v-bind:viewDatalist="pdData" v-bind:autoPublisher="auto_publisher" v-bind:publisherPlatforms="publisher_platforms" v-bind:lang="showLang[selectLang]" />
          <Identity v-bind:showIdentity="showIdentity" v-bind:editPage="cancelEdit" v-bind:viewDatalist="idData" v-bind:lang="showLang[selectLang]" @childPageId="eventPageId" />
          <Material v-if="false" v-bind:editPage="cancelEdit" v-bind:viewDatalist="postData" v-bind:pageId="formPageId" v-bind:goalsObjective="getGoalsObjective" v-bind:campaign_objective="goalsData.campaign_objective" v-bind:campaignId="this.$route.params.campaign_id" v-bind:lang="showLang[selectLang]" v-bind:efficientAi="efficientAi" @childIsChangeData="materialChange" @childActiveScroll="activeScroll" />
          <AdvertisingMaterial v-bind:editPage="cancelEdit" v-bind:viewDatalist="adMaterialDataNew" v-bind:pageId="formPageId" v-bind:goalsObjective="getGoalsObjective" v-bind:returnCampaignObjective="returnCampaignObjective" v-bind:changeFormId="changeFormId" v-bind:lang="showLang[selectLang]" @childFormId="eventFormId" @childMessageId="eventMessageId" @childContent="adMaterialContent" @childAdIsChangeData="adMaterialChange" :style="showAdvertisingMaterial ? '' : 'display:none;'" />
          <Form v-if="false" v-bind:editPage="cancelEdit" v-bind:viewDatalist="idData" v-bind:pageId="formPageId" v-bind:firstFormId="first_form_id" v-bind:formStatus="form_status" v-bind:formId="formId" v-bind:useTeachDetail="use_teach_detail" v-bind:selectLang="selectLang" v-bind:lang="showLang[selectLang]" @childChangeFormId="formChangeFormId" />
          <Msg v-if="false" v-bind:editPage="cancelEdit" v-bind:viewDatalist="idData" v-bind:pageId="formPageId" v-bind:firstMessageId="first_message_id" v-bind:messageStatus="message_status" v-bind:messageId="messageId" v-bind:useTeachDetail="use_teach_detail" v-bind:lang="showLang[selectLang]" />
        </div>
      </div>
    </main>
    <footer class="block bg-white fixed w-full bottom-0">
      <div v-if="false" class="h-1 bg-green-700 progressbar" style="width:20%" :style="{width: `${process}%`}"></div>
      <div class="mx-auto pl-8 pr-28 py-4">
        <div class="flex flex-wrap items-center md:justify-between justify-center">
          <div class="border-gray-400 space-x-2">
            <!-- <button
              v-if="!efficientAi"
              class="bg-blue-600 hover:bg-blue-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-white transition duration-500 ease-in-out border-2 border-blue-400"
              @click="form_update()"
              >{{showLang[selectLang]['views']['EventBrowse']['save_button']}}</button> -->
            <button
              class="bg-blue-600 hover:bg-blue-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-white transition duration-500 ease-in-out border-2 border-blue-400"
              @click="form_update()"
              >{{showLang[selectLang]['views']['EventBrowse']['save_button']}}</button>
            <button
              class="bg-yellow-300 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-800 transition duration-500 ease-in-out border-2 border-yellow-400" v-if="false">{{showLang[selectLang]['views']['EventBrowse']['release_button']}}</button>
          </div>
          <div class="border-gray-400 space-x-2">
            <span v-if="false">{{showLang[selectLang]['views']['EventBrowse']['process_text_a']}} {{process}} % {{showLang[selectLang]['views']['EventBrowse']['process_text_b']}}</span>
          </div>
          <div class="border-gray-400 space-x-2 mr-16">
            <button
              v-if="target != 1"
              class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
              @click="prev()"
              :disabled="process <= 0"
            >{{showLang[selectLang]['views']['EventBrowse']['prev_text']}}</button>
            <button
              v-if="target != 3"
              class="hover:bg-green-200 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-green-400 border-2 bg-green-400"
              @click="next()"
              :disabled="process >= 66"
            >{{showLang[selectLang]['views']['EventBrowse']['next_text']}}</button>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import CampaignName from '@/components/TikTokEvent/CampaignName.vue'
  import MarketingMethod from '@/components/TikTokEvent/MarketingMethod.vue'
  import MarketingDate from '@/components/TikTokEvent/MarketingDate.vue'
  import KeywordMix from '@/components/TikTokEvent/KeywordMix.vue'
  import AdvertisingMix from '@/components/TikTokEvent/AdvertisingMix.vue'
  import GoalsAndBudget from '@/components/TikTokEvent/GoalsAndBudget.vue'
  import Regions from '@/components/TikTokEvent/Regions.vue'
  import Identity from '@/components/TikTokEvent/Identity.vue'
  import Relationship from '@/components/TikTokEvent/Relationship.vue'
  import PositionAndDevice from '@/components/TikTokEvent/PositionAndDevice.vue'
  import Material from '@/components/TikTokEvent/Material.vue'
  import AdvertisingMaterial from '@/components/TikTokEvent/AdvertisingMaterial.vue'
  import Form from '@/views/Form.vue'
  import Msg from '@/views/Msg.vue'
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import CircleProgress from "vue3-circle-progress";
  import axios from 'axios'
  import Qs from 'qs'
  import lang from '@/language/tiktok_lang.json'

  export default {
    name: 'Home',
    components: {
      Header,
      CampaignName,
      MarketingMethod,
      MarketingDate,
      KeywordMix,
      AdvertisingMix,
      GoalsAndBudget,
      Regions,
      Identity,
      Relationship,
      PositionAndDevice,
      Material,
      AdvertisingMaterial,
      Form,
      Msg,
      Loading,
      CircleProgress
    },
    data() {
      return {
        selectLang: 'zh-TW',
        showLang: lang,
        use_teach_detail: false, // <!-- 新手教學 -->
        showCampaignData: false,
        showMarketingDate: true,
        showAdvertisingMix:true,
        showGoalsAndBudget: true,
        showRelationship: true,
        showIdentity: true,
        display: false,
        cancelEdit: true,
        process: 0,
        showTargetKW: true,
        showTargetDM: true,
        showTargetLA: true,
        returnCampaignObjective: null,
        returnGapTime: null,
        returnEndTime: null,
        returnUseEndDate: null,
        budgetKW:null,
        updateMinAddition: 0,
        getGoalsObjective: null,
        showMaterial:true,
        showAdvertisingMaterial:true,
        showForm:true,
        showMsg:true,
        isEdit: false,
        campaign_id: null,
        campaign_name: null,
        adaccount_id: null,
        adaccount_name: null,
        target: 1,
        formPageId: null,
        formId: null,
        messageId: null,
        changeFormId: null,
        dbRiskLevelCode: null,
        menu: [],
        currencyData: {
                      currency: '',
                      currency_name: null,
                      currency_symbol: null,
                      currency_min_price: null,
                      currency_video_min_price: null,
                      currency_suggest_price: null,
                      currency_remarketing_price: null
                    },
        methodData: {
                    Target_KW:null,
                    Budget_KW:null,
                    Target_DM:null,
                    Budget_DM:null,
                    Target_LA:null,
                    Budget_LA:null,
                    Target_RT:null,
                    Budget_RT:null,
                    use_confldential_audience_status:0,
                    Target_CF:null,
                    Budget_CF:null,
                    Target_AD:null,
                    Budget_AD_min:null,
                    Budget_AD_max:null,
                    retargeting:null,
                    daily_budget:null
                  },
        dateData: {
                    start_date:null,
                    end_date:null
                  },
        keywordData: {
                      product_url:null,
                      keywords:null,
                      base_keyword_list: [],
                      select_keywords:null,
                      creator_action_categories: [],
                      interest_categories: [],
                      video_action_categories: [],
                      interest_keywords: [],
                      hashtags: [],
                    },
        lookData: {
                    default_lookalikes:null,
                    custom_lookalikes:null,
                    custom_lookalikes_selected:null,
                    default_lookalikes_list:null,
                    custom_lookalikes_list:null
                  },
        goalsData: {
                    campaign_objective:null,
                    objective_option:null,
                    objective_list:null,
                    product_catalog_list:null,
                    product_set_list:null,
                    optimization_action:null,
                    optimization_goal:null,
                    product_catalog_id:null,
                    product_set_id:null,
                    pixel_id:null,
                    pixel_event:null,
                    conversion_domain:null,
                    domain_list:null,
                    useAppEvent: false,
                    appItemsSelected: null,
                    appItemsList: [],
                    effect:null,
                    currency_video_min_price:null,
                    form_addition:null,
                    use_addition:null,
                    risk_automatic:null,
                    risk_index:null,
                    risk_level_list:null,
                    risk_level:null
                  },
        regionsData: {
                      location_types:null,
                      locations:null,
                      locales:null,
                      gender:null,
                      age_min:null,
                      age_max:null
                    },
        selectCountries: null,
        selectLangs: null,
        exAudiencesData: {
                      excluded_audiences:null,
                      default_excluded_audiences:null,
                      custom_excluded_audiences:null,
                      custom_excluded_audiences_selected:null,
                    },
        pdData: {
                  auto_publisher:null,
                  publisher_platforms:null,
                  publisher_platforms_list:null,
                  device_platforms: null,
                  user_os:null,
                  user_os_list:null,
                },
        auto_publisher: null,
        publisher_platforms: null,
        idData: {
                  page_id:null,
                  ig_id:null,
                  ig_username:null,
                  adpages_list:null,
                  ig_list:null,
                },
        postData: {
                  page_id:null,
                  special_ad_category:null,
                  disabled_creative_optimize:false,
                  creative_optimize:false,
                  select_article:null,
                  delete_article:null,
                  db_select_article:null,
                  select_creatives:null,
                  delete_creatives:null,
                  db_select_creatives:null,
                  select_creatives_message:null,
                  delete_creatives_message:null,
                  db_select_creatives_message:null,
                  select_creatives_adset_ads:null,
                  delete_creatives_adset_ads:null,
                  db_select_creatives_adset_ads:null,
                  material_creative_tags:null,
                  material_post_tags:null,
                  material_post_delete_tags:null,
                  material_creative_delete:null,
                  material_creative_delete_adset_ads:null,
                },
        adMaterialData: {
                          disabled_creative_optimize:false,
                          creative_optimize:false,
                          creative_array:null,
                        },
        tmpAdMaterialDataNew:{
                            disabled_creative_optimize:false,
                            creative_optimize:false,
                            creative_array:null,
                          },
        adMaterialDataNew:{
                            disabled_creative_optimize:false,
                            creative_optimize:false,
                            creative_array:null,
                          },
        formData: {
                    pageId: null,
                    formId: null
                  },
        msgData: {
                    pageId: null,
                    msgId: null
                  },
        first_form_id: null,
        form_status: null,
        first_message_id: null,
        message_status: null,
        adMaterialJsonData: [],
        isChangeDataMaterial: false,
        isChangeDataAdMaterial: false,
        releaseType: true,
        efficientAi: null,
        style: 'z-index: -1;',
        releaseText: '發佈中...',
        releasePercent: 5,
      }
    },
    created() {
      // console.log('id:'+this.$route.params.id);
      // console.log('adaccount_id:'+this.$route.params.adaccount_id);
      // console.log('campaign_id:'+this.$route.params.campaign_id);

      let hash = this.$route.params.id;

      if(hash != '' && hash != null && typeof hash != 'undefined'){
        axios
          .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign.php', Qs.stringify({
            s_code: this.$route.params.id,
            advertiser_id: this.$route.params.adaccount_id,
            campaign_id: this.$route.params.campaign_id
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.campaign_id = this.$route.params.campaign_id
              this.campaign_name = response.data.return_data.campaign_name
              this.advertiser_id = response.data.return_data.adaccount_id
              this.adaccount_name = response.data.return_data.adaccount_name

              document.title = response.data.return_data.campaign_name+' - '+this.showLang[this.selectLang]['views']['EventBrowse']['created']['page_title']+' - AutoTurn';

              this.showTargetKW = response.data.return_data.Target_KW
              this.showTargetLA = response.data.return_data.Target_LA

              let startTime = response.data.return_data.start_date;
              let endTime = response.data.return_data.end_date;
              let diffType = 'day';

              let gapTime = 0;

              if(startTime != '' && startTime != '0000-00-00' && startTime != null && endTime != '' && endTime != '0000-00-00' && endTime != null){
                diffType = diffType.toLowerCase();
                var sTime =new Date(startTime); //開始時間
                var eTime =new Date(endTime); //結束時間
                //作為除數的數字
                var timeType = 1;
                switch (diffType) {
                    case"second":
                        timeType =1000;
                    break;
                    case"minute":
                        timeType =1000*60;
                    break;
                    case"hour":
                        timeType =1000*3600;
                    break;
                    case"day":
                        timeType =1000*3600*24;
                    break;
                    default:
                    break;
                }
                gapTime = parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
              }

              this.budgetKW = response.data.return_data.Budget_KW;
              this.returnGapTime = gapTime;
              this.returnEndTime = response.data.return_data.end_date;
              this.returnUseEndDate = response.data.return_data.use_end_date;

              this.currencyData = {
                                    currency: response.data.return_data.currency,
                                    currency_name: response.data.return_data.currency_name,
                                    currency_symbol: response.data.return_data.currency_symbol,
                                    currency_min_price: response.data.return_data.currency_min_price,
                                    currency_video_min_price: response.data.return_data.currency_video_min_price,
                                    currency_suggest_price: response.data.return_data.currency_suggest_price,
                                    currency_remarketing_price: response.data.return_data.currency_remarketing_price,
                                    KW_min_price: response.data.return_data.KW_min_price,
                                    DM_min_price: response.data.return_data.DM_min_price,
                                    LA_min_price: response.data.return_data.LA_min_price,
                                    RT_min_price: response.data.return_data.RT_min_price,
                                  }

              this.methodData = {
                                  Target_KW : response.data.return_data.Target_KW,
                                  Budget_KW : response.data.return_data.Budget_KW
                                }

              if(response.data.return_data.Target_LA == '1'){
                var todayForm = new Date();
                var yearForm = todayForm.getFullYear();
                var dateForm = String(todayForm.getDate()).padStart(2, '0');
                var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                let get_value = 'false_'+yearForm + monthForm + dateForm + timeForm;

                this.showAdvertisingMix = get_value;
              }

              this.dateData = {
                                start_date : response.data.return_data.start_date,
                                end_date : response.data.return_data.end_date
                              }

              this.keywordData = {
                                    product_url : response.data.return_data.product_url,
                                    keywords : response.data.return_data.keywords,
                                    select_keywords : response.data.return_data.keywords,
                                    creator_action_categories: response.data.return_data.creator_action_categories,
                                    interest_categories: response.data.return_data.interest_categories,
                                    video_action_categories: response.data.return_data.video_action_categories,
                                    interest_keywords: response.data.return_data.interest_keywords,
                                    hashtags: response.data.return_data.hashtags,
                                  },

              this.lookData = {
                                default_lookalikes : response.data.return_data.default_lookalikes,
                                custom_lookalikes : response.data.return_data.custom_lookalikes,
                                custom_lookalikes_selected : response.data.return_data.custom_lookalikes_selected,
                                default_lookalikes_list : response.data.return_data.default_lookalikes_list,
                                custom_lookalikes_list : response.data.return_data.custom_lookalikes_list
                              }

              this.goalsData = {
                                  objective_list : response.data.return_data.objective_list,
                                  objective_type : response.data.return_data.objective_type,
                                  objective_option : response.data.return_data.objective_option,
                                  effect : response.data.return_data.effect,
                                  currency_video_min_price: response.data.return_data.currency_video_min_price,
                                  budget_increase : response.data.return_data.budget_increase,
                                  budget_switch : response.data.return_data.budget_switch,
                                  risk_automatic : response.data.return_data.risk_automatic,
                                  risk_level_list: response.data.return_data.risk_level_list,
                                  risk_level: response.data.return_data.risk_level
                                }

              this.returnCampaignObjective = response.data.return_data.campaign_objective

              this.dbRiskLevelCode = response.data.return_data.risk_level.code

              this.regionsData = {
                                    locations_list : response.data.return_data.locations_list,
                                    locations_selected : response.data.return_data.locations_selected,
                                    locations : response.data.return_data.locations,
                                    locales : response.data.return_data.locales,
                                    locales_list : response.data.return_data.locales_list,
                                    locales_selected : response.data.return_data.locales_selected,
                                    gender : response.data.return_data.gender,
                                    age_groups : response.data.return_data.age_groups
                                  }

              this.selectCountries = response.data.return_data.locations

              this.selectLangs = response.data.return_data.locales

              axios
                .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_audiences_list.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  advertiser_id: this.$route.params.adaccount_id,
                  excluded_audiences: response.data.return_data.excluded_audiences
                }))
                .then((exResponse) => {
                  console.log('exResponse');
                  console.log(exResponse);
                  this.exAudiencesData = {
                                            excluded_audiences : response.data.return_data.excluded_audiences,
                                            excluded_audiences_list : exResponse.data.excluded_audiences_list,
                                            default_excluded_audiences : response.data.return_data.default_excluded_audiences,
                                            custom_excluded_audiences : response.data.return_data.custom_excluded_audiences,
                                            custom_excluded_audiences_selected : response.data.return_data.custom_excluded_audiences_selected,
                                          }
                });

              this.pdData = {
                              auto_publisher : response.data.return_data.auto_publisher,
                              publisher_platforms : response.data.return_data.publisher_platforms,
                              publisher_platforms_list : response.data.return_data.publisher_platforms_list,
                              placement_type : response.data.return_data.placement_type,
                              placements : response.data.return_data.placements,
                              device_platforms: response.data.return_data.device_platforms,
                              operating_systems : response.data.return_data.operating_systems,
                              user_os_list : response.data.return_data.user_os_list
                            }

              this.auto_publisher = response.data.return_data.auto_publisher
              this.publisher_platforms = response.data.return_data.publisher_platforms

              this.idData = {
                              identity_id : response.data.return_data.identity_id,
                              adpages_list : response.data.return_data.adpages_list,
                            }

              this.postData = {
                                page_id : response.data.return_data.page_id,
                                special_ad_category : response.data.return_data.special_ad_category,
                                disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                creative_optimize : response.data.return_data.creative_optimize,
                                db_select_article : response.data.return_data.post_ids,
                                db_select_creatives : response.data.return_data.creatives_ids,
                                db_select_creatives_message : response.data.return_data.creatives_message_ids,
                                db_select_creatives_adset_ads : response.data.return_data.creatives_ids_adset_ads,
                                material_creative_tags : response.data.return_data.material_creative_tags,
                                material_post_tags : response.data.return_data.material_post_tags,
                                material_post_delete_tags : response.data.return_data.material_post_delete_tags,
                                material_creative_delete : response.data.return_data.material_creative_delete,
                                material_creative_message_delete : response.data.return_data.material_creative_message_delete,
                                material_creative_delete_adset_ads : response.data.return_data.material_creative_delete_adset_ads,
                              }

              console.log('main this.postData');
              console.log(this.postData);

              // if(response.data.return_data.campaign_objective == 'PRODUCT_CATALOG_SALES'){
              //   this.postData.db_select_creatives_adset_ads = response.data.return_data.creatives_ids;
              // } else {
              //   this.postData.db_select_creatives = response.data.return_data.creatives_ids;
              // }

              this.adMaterialData = {
                                      disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                      creative_optimize : response.data.return_data.creative_optimize,
                                      creative_array : response.data.return_data.creative_array,
                                    }

              this.tmpAdMaterialDataNew = {
                                            disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                            creative_optimize : response.data.return_data.creative_optimize,
                                            creative_array : response.data.return_data.creative_array
                                          }

              for(let i = 0; i < response.data.return_data.creative_array.length; i++){
                this.adMaterialJsonData[response.data.return_data.creative_array[i].c_sr_i] = JSON.stringify(response.data.return_data.creative_array[i]);
              }

              this.formPageId = response.data.return_data.page_id

              console.log('this.tmpAdMaterialDataNew');
              console.log(this.tmpAdMaterialDataNew);

              this.minAddition(response.data.return_data.form_addition, gapTime, response.data.return_data.Budget_KW, this.returnUseEndDate);
            }

            if(response.data.status == 'login'){
              Swal.fire({
                icon: 'error',
                title: '瀏覽/編輯頁',
                text: '會員資料已過期，請重新登入。',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: '確定'
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                }
              })
            }

            this.showCampaignData = true;
          });
      } else {
        Swal.fire({
          icon: 'error',
          title: this.showLang[this.selectLang]['views']['EventBrowse']['created']['no_hash_swal_title'],
          text: this.showLang[this.selectLang]['views']['EventBrowse']['created']['no_hash_swal_text'],
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['created']['no_hash_swal_confirm_button']
          // denyButtonText: `Don't save`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            // Swal.fire('Saved!', '', 'success')
            // this.allPageLoading = true
            window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
          } else if (result.isDenied) {
            // Swal.fire('Changes are not saved', '', 'info')
            // this.allPageLoading = true
            window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
          }
        })
      }
    },
    Watch:{
      // 'formPageId': function(v){
      //   console.log('event formPageId');
      //   console.log(v);
      // },
      // 'idData.page_id': function(v){
      //   console.log('event idData.page_id');
      //   console.log(v);
      // }
    },
    methods: {
      useLang(v){
        console.log('event methods useLang');
        console.log(v);

        if(v == '' || v == null || typeof v == 'undefined'){
          v = 'zh-TW';
        }

        this.selectLang = v

        this.$emit('childLang', v);

        console.log('useLang this.selectLang');
        console.log(this.selectLang);
        console.log('this.showLang['+v+']');
        console.log(this.showLang[v]);

        this.menu = [
          {
            title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_1_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_1_submenu_0_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_1_submenu_1_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_1_submenu_2_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_1_submenu_5_title'], show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 1
          },
          // {
          //   title: '關鍵字與受眾',
          //   submenu: [
          //     {title: '精準興趣關鍵字', show: true, checked: false},
          //     {title: '類似受眾廣告組合', show: true, checked: false},
          //   ],
          //   open: true,
          //   show: true,
          //   target: 2
          // },
          {
            title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_2_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_2_submenu_1_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_2_submenu_2_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_2_submenu_3_title'], show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 2
          },
          {
            title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_3_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_3_submenu_1_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_3_submenu_2_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_3_submenu_3_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventBrowse']['menu']['step_3_submenu_4_title'], show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 3
          },
        ];
      },
      minAddition(budgetAddition, day, budgetKW, useEndDate){
        // console.log('value budgetAddition:'+budgetAddition);

        // console.log('getDate budgetAddition:'+day);
        // console.log('budgetKWTotal budgetAddition:'+budgetKW);
        // console.log('useEndDate budgetAddition:'+useEndDate);

        // if(useEndDate == false){
        //   //有結束日期
        //   // console.log('有結束日期');
        //   //先算精準興趣總預算

        //   if(!isNaN(day) && day > 0){
        //     // console.log('有日期間距');
        //     var _tmp_days = day;
        //     var _tmp_total = budgetKW;
        //     // var _tmp_budget_addition = (budget_addition == '' || budget_addition == 0)?0:budget_addition/100
        //     var _tmp_interval_week = 0;
        //     var interval_week = 0;
        //     var n = 0;
        //     var html = 0;
        //     var video_min_price = this.currencyData.currency_video_min_price;
        //     var _tmp_budget_addition = video_min_price;

        //     let _test_total = 0;

        //     if(_tmp_days > 0){
        //         if(_tmp_days > 3){
        //             n = Math.round(_tmp_days/7);
        //         }
        //     }

        //     //console.log(_tmp_total+'*7');
        //     var first_week = _tmp_total*7;

        //     for(var i = 1; i < n; i++){
        //         var days_pow = i + 1;
        //         // console.log('days_pow:'+days_pow);
        //         // console.log(_tmp_total+' * Math.pow((1 + '+_tmp_budget_addition+'), '+days_pow+') * 7');

        //         //console.log('('+_tmp_total +'+ ('+days_pow+' - 1) * '+_tmp_budget_addition+') * 7');
        //         _tmp_interval_week = (parseInt(_tmp_total) + (parseInt(days_pow) - 1) * parseInt(_tmp_budget_addition)) * 7;

        //         // console.log(interval_week +'='+ interval_week +'+'+ _tmp_interval_week);
        //         interval_week = interval_week + _tmp_interval_week;
        //     }

        //     // console.log(_tmp_total + ' * Math.pow((1 + '+_tmp_budget_addition+'), '+n+') * ('+_tmp_days+' - 7 * '+n+')');

        //     //console.log('('+_tmp_total +'+'+ n +'*'+ _tmp_budget_addition+') * ('+_tmp_days +' - 7 * '+ n+')');
        //     var finish_week = (parseInt(_tmp_total) + parseInt(n) * parseInt(_tmp_budget_addition)) * (parseInt(_tmp_days) - 7 * parseInt(n));

        //     if(_tmp_days > 0 && _tmp_total > 0){
        //         // console.log('Math.round('+first_week +'+'+ interval_week +'+'+ finish_week+')');
        //         html = Math.round(parseInt(first_week) + parseInt(interval_week) + parseInt(finish_week));
        //     }

        //     _test_total = html;

        //     //計算最低預算比率
        //     let _ratio = ((Math.ceil(((parseInt(_test_total) / (parseInt(_tmp_total) * parseInt(_tmp_days))))*100)/100 - 1)*100).toFixed(0);

        //     this.updateMinAddition = _ratio;

        //     if(parseInt(budgetAddition) < parseInt(_ratio)){
        //       // console.log('有結束日期之下，不允許小於:'+_ratio);
        //       this.goalsData.form_addition = _ratio;
        //     } else {
        //       // console.log(budgetAddition +" > "+ _ratio);
        //     }
        //   } else {
        //     // console.log('沒結束日期也沒日期間距');
        //     var _tmp_keyword_split_budget = budgetKW;
        //     var video_min_price = this.currencyData.currency_video_min_price;
        //     var single_ratio = Math.ceil((video_min_price/(parseInt(_tmp_keyword_split_budget)))*100);
        //     if(_tmp_keyword_split_budget == 0){
        //         single_ratio = 0;
        //     }

        //     this.updateMinAddition = single_ratio;

        //     if(parseInt(budgetAddition) < parseInt(single_ratio)){
        //       // console.log('沒結束日期之下，不允許小於:'+single_ratio);
        //       this.goalsData.form_addition = single_ratio;
        //     } else {
        //       // console.log(budgetAddition +" > "+ single_ratio);
        //     }
        //   }

        // } else {
        //   //沒結束日期
        //   // console.log('沒結束日期');
        //   // console.log(this.currencyData.currency_video_min_price);
        //   // console.log(budgetKW);
        //   var _tmp_keyword_split_budget = budgetKW;
        //   var video_min_price = this.currencyData.currency_video_min_price;
        //   var single_ratio = Math.ceil((video_min_price/(parseInt(_tmp_keyword_split_budget)))*100);
        //   if(_tmp_keyword_split_budget == 0){
        //       single_ratio = 0;
        //   }

        //   this.updateMinAddition = single_ratio;

        //   if(budgetAddition < single_ratio){
        //     // console.log('沒結束日期之下，不允許小於:'+single_ratio);
        //     this.goalsData.form_addition = single_ratio;
        //   } else {
        //     // console.log(budgetAddition +" > "+ single_ratio);
        //   }
        // }

        // console.log('update this.updateMinAddition:'+this.updateMinAddition);

        // return 'string form test_call';
      },
      methodTargetKW(value){
        // console.log('methods childTargetKW')
        // console.log(value);
        this.showTargetKW = value
        // this.menu[0].submenu[1].show = value

        // if(!this.menu[1].submenu[0].show && !this.menu[1].submenu[1].show){
        //   this.menu[1].show = false
        // } else {
        //   this.menu[1].show = true
        // }
      },
      methodTargetDM(value){
        // console.log('methods childTargetDM')
        // console.log(value);
        this.showTargetDM = value

        if(value == true){
          // if(this.getGoalsObjective == 'CONVERSIONS'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 65;
          // }
          // if(this.getGoalsObjective == 'LINK_CLICKS'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }
          // if(this.getGoalsObjective == 'POST_ENGAGEMENT'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }
          // if(this.getGoalsObjective == 'VIDEO_VIEWS'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }
          // if(this.getGoalsObjective == 'LEAD_GENERATION'){
          //   this.regionsData.age_min = 18;
          //   this.regionsData.age_max = 65;
          // }
          // if(this.getGoalsObjective == 'MESSAGES'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }

          // this.regionsData.age_min = 13;
          // this.regionsData.age_max = 65;
        }

        // console.log(this.regionsData);
      },
      methodTargetLA(value){
        // console.log('methods childTargetLA')
        // console.log(value);
        this.showTargetLA = value
        // this.menu[0].submenu[2].show = value

        // if(!this.menu[1].submenu[0].show && !this.menu[1].submenu[1].show){
        //   this.menu[1].show = false
        // } else {
        //   this.menu[1].show = true
        // }
      },
      methodTargetAD(value){
        // console.log('methodTargetAD');
        // console.log(value);

        this.efficientAi = value;

        // this.dateData.end_date = '0000-00-00';
        // console.log('this.dateData.end_date');
        // console.log(this.dateData.end_date);
      },
      goalsObjective(value){
        // console.log('goalsObjective')
        // console.log(value);

        // this.getGoalsObjective = value

        // if(this.showTargetDM == true){
        //   if(value == 'CONVERSIONS'){
        //     // this.regionsData.age_min = 13;
        //     this.regionsData.age_max = 65;
        //   }
        //   if(value == 'LINK_CLICKS'){
        //     // this.regionsData.age_min = 13;
        //     this.regionsData.age_max = 64;
        //   }
        //   if(value == 'POST_ENGAGEMENT'){
        //     // this.regionsData.age_min = 13;
        //     this.regionsData.age_max = 64;
        //   }
        //   if(value == 'VIDEO_VIEWS'){
        //     // this.regionsData.age_min = 13;
        //     this.regionsData.age_max = 64;
        //   }
        //   if(value == 'LEAD_GENERATION'){
        //     // this.regionsData.age_min = 18;
        //     this.regionsData.age_max = 65;
        //   }
        //   if(value == 'MESSAGES'){
        //     // this.regionsData.age_min = 13;
        //     this.regionsData.age_max = 64;
        //   }
        // }

        // if(value == 'CONVERSIONS'){
        //   this.showMaterial = true;
        //   this.showAdvertisingMaterial = false;
        //   this.showForm = false;
        //   this.showMsg = false;

        //   this.adMaterialData.creative_array = []
        // }
        // if(value == 'LINK_CLICKS'){
        //   this.showMaterial = true;
        //   this.showAdvertisingMaterial = false;
        //   this.showForm = false;
        //   this.showMsg = false;

        //   this.adMaterialData.creative_array = []
        // }
        // if(value == 'POST_ENGAGEMENT'){
        //   this.showMaterial = true;
        //   this.showAdvertisingMaterial = false;
        //   this.showForm = false;
        //   this.showMsg = false;

        //   this.adMaterialData.creative_array = []
        // }
        // if(value == 'VIDEO_VIEWS'){
        //   this.showMaterial = true;
        //   this.showAdvertisingMaterial = false;
        //   this.showForm = false;
        //   this.showMsg = false;

        //   this.adMaterialData.creative_array = []
        // }
        // if(value == 'LEAD_GENERATION'){
        //   this.showMaterial = false;
        //   this.showAdvertisingMaterial = true;
        //   this.showForm = true;
        //   this.showMsg = false;

        //   // if(this.adMaterialData.creative_array == null){
        //   //   this.adMaterialData.creative_array = [
        //   //     {
        //   //       title: "xxxx",
        //   //       isEdit: false,
        //   //       type: 1,
        //   //       materials:[],
        //   //       materialSingle: [
        //   //         {
        //   //           src: null,
        //   //           title: null,
        //   //           size: null
        //   //         }
        //   //       ],
        //   //       callActive: 'SIGN_UP'
        //   //     }
        //   //   ]
        //   // }
        // }
        // if(value == 'MESSAGES'){
        //   this.showMaterial = true;
        //   this.showAdvertisingMaterial = true;
        //   this.showForm = false;
        //   this.showMsg = true;

        //   // if(this.adMaterialData.creative_array == null){
        //   //   this.adMaterialData.creative_array = [
        //   //     {
        //   //       title: "xxxx",
        //   //       isEdit: false,
        //   //       type: 1,
        //   //       materials:[],
        //   //       materialSingle: [
        //   //         {
        //   //           src: null,
        //   //           title: null,
        //   //           size: null
        //   //         }
        //   //       ],
        //   //       callActive: 'SIGN_UP'
        //   //     }
        //   //   ]
        //   // }
        // }

        // if(value == 'PRODUCT_CATALOG_SALES'){
        //   this.showMaterial = true;
        //   this.showAdvertisingMaterial = false;
        //   this.showForm = false;
        //   this.showMsg = false;

        //   this.postData.select_article = [];
        //   this.postData.select_creatives = [];
        // } else {
        //   this.postData.select_creatives_adset_ads = [];
        // }

        this.adMaterialDataNew = this.tmpAdMaterialDataNew

        // console.log('this.showMaterial:'+this.showMaterial);
        // console.log('this.showAdvertisingMaterial:'+this.showAdvertisingMaterial);
        // console.log('this.showForm:'+this.showForm);
        // console.log('this.showMsg:'+this.showMsg);

        console.log('goalsObjective this.adMaterialDataNew');
        console.log(this.adMaterialDataNew);
      },
      getHere(target){
        this.target = target

        // if(this.menu[1].show == false){
        //   if (target > 1) {
        //     target -= 1
        //   }
        //   this.process = parseInt(33) * (parseInt(target) - parseInt(1))
        // } else {
        //   this.process = parseInt(25) * (parseInt(target) - parseInt(1))
        // }

        this.process = parseInt(33) * (parseInt(target) - parseInt(1))

        document.getElementById('edit_content').scrollTop = 0;
      },
      eventPageId(value) {
        // console.log('methods eventPageId')
        // console.log(value);
        this.formPageId = value
      },
      eventFormId(value) {
        // console.log('methods eventFormId')
        // console.log(value);
        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = value+'_'+yearForm + monthForm + dateForm + timeForm;
        if(value != '' && value != null && typeof value != 'undefined'){
          this.formId = get_value
        } else {
          this.formId = []
        }
      },
      eventMessageId(value) {
        // console.log('methods eventMessageId')
        // console.log(value);
        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = value+'_'+yearForm + monthForm + dateForm + timeForm;
        if(value != '' && value != null && typeof value != 'undefined'){
          this.messageId = get_value
        } else {
          this.messageId = []
        }
      },
      materialChange(value){
        console.log('老爸知道有變動 materialChange')
        console.log(value);
        this.isChangeDataMaterial = value
      },
      adMaterialChange(value){
        console.log('adMaterialChange')
        console.log(value);
        this.isChangeDataAdMaterial = value
      },
      adMaterialContent(value){
        console.log('adMaterialContent')
        console.log(value);
        if(typeof value.creative_array != 'undefined'){
          this.adMaterialDataNew = value
        } else {
          this.adMaterialDataNew.creative_array = value
        }
      },
      formChangeFormId(value){
        console.log('formChangeFormId')
        console.log(value);

        this.changeFormId = value
      },
      activeScroll(value){

        let tmpDataType = value.split('_');

        if(tmpDataType[0] == 1){
          this.$refs.scrollcontent.scrollTo({
            top: 1505,
            behavior: 'smooth'
          });
        }
      },
      prev() {
        // console.log('now target:'+this.target);
        // if(this.menu[1].show == false){
          this.process -= 33
          if (this.target > 1) {
            this.target -= 1

            // if(this.target == 2){
            //   this.target -= 1
            // }
          }
        // } else {
        //   this.process -= 25
        //   if (this.target > 1) {
        //     this.target -= 1
        //   }
        // }
        // console.log('prev target:'+this.target);
        document.getElementById('edit_content').scrollTop = 0;
      },
      next() {
        // console.log('now target:'+this.target);
        // if(this.menu[1].show == false){
          this.process += 33
          // console.log('now target:'+this.target);
          if (this.target <= 3) {
            this.target += 1
            this.menu[this.target-1].open = true
          }
          // if(this.target == 2){
          //   this.target += 1
          // }
        // } else {
        //   this.process += 25
        //   // console.log('now target:'+this.target);
        //   if (this.target <= 4) {
        //     this.target += 1
        //     this.menu[this.target-1].open = true
        //   }
        //   // console.log('next target:'+this.target);
        // }
        // console.log('next target:'+this.target);
        document.getElementById('edit_content').scrollTop = 0;
      },
      form_update(){
        // console.log('form_update');

        // console.log('this.postData');
        // console.log(this.postData);
        // console.log('this.adMaterialDataNew');
        // console.log(this.adMaterialDataNew);

        let error = 0;

        if(this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null){
          Swal.fire(
                    this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['empty_effect_swal_title'],
                    this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['empty_effect_swal_text'],
                    "warning"
                  )

          error = 1;
        }

        console.log('1 error');
        console.log(error);

        console.log('this.goalsData.campaign_objective');
        console.log(this.goalsData.campaign_objective);

        // if(this.goalsData.campaign_objective == 'CONVERSIONS' || this.goalsData.campaign_objective == 'LINK_CLICKS' || this.goalsData.campaign_objective == 'POST_ENGAGEMENT' || this.goalsData.campaign_objective == 'VIDEO_VIEWS'){

        //   let select_article_length = 0;
        //   if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
        //     select_article_length = this.postData.select_article.length;
        //   }

        //   let select_creatives_length = 0;
        //   if(this.postData.select_creatives != '' && this.postData.select_creatives != null && typeof this.postData.select_creatives != 'undefined'){
        //     select_creatives_length = this.postData.select_creatives.length;
        //   }

        //   let select_creatives_adset_ads_length = 0;
        //   if(this.postData.select_creatives_adset_ads != '' && this.postData.select_creatives_adset_ads != null && typeof this.postData.select_creatives_adset_ads != 'undefined'){
        //     select_creatives_adset_ads_length = this.postData.select_creatives_adset_ads.length;
        //   }

        //   console.log('select_article_length');
        //   console.log(select_article_length);

        //   console.log('select_creatives_length');
        //   console.log(select_creatives_length);

        //   console.log('select_creatives_adset_ads_length');
        //   console.log(select_creatives_adset_ads_length);

        //   if(select_article_length <= 0 && select_creatives_length <= 0 && select_creatives_adset_ads_length <= 0){
        //     error = 1;

        //     Swal.fire(
        //       this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['empty_select_article_swal_title'],
        //       this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['empty_select_article_swal_text'],
        //       'error'
        //     )
        //   }
        // }

        console.log('2 error');
        console.log(error);

        console.log('this.adMaterialDataNew');
        console.log(this.adMaterialDataNew);

        // if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
        //   let materialType = 0;
        //   let selectArticleLength = 0;
        //   if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
        //     selectArticleLength = this.postData.select_article.length;
        //   }

        //   let selectCreativesMessageLength = 0;
        //   if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
        //     selectCreativesMessageLength = this.postData.select_creatives_message.length;
        //   }

        //   let creativeArrayLength = 0;
        //   if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
        //     creativeArrayLength = this.adMaterialDataNew.creative_array.length;
        //   }

        //   if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
        //     materialType = 1;
        //   } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
        //     materialType = 2;
        //   }

        //   if(materialType != 0){
        //     error = 1;

        //     Swal.fire(
        //       this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['empty_creative_array_swal_title'],
        //       this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['empty_creative_array_swal_text'],
        //       'error'
        //     )
        //   }
        // }

        let adMaterialDataNewCreativeArrayLength = this.adMaterialDataNew.creative_array.length;
        let isChange = [];

        if(adMaterialDataNewCreativeArrayLength > 0){
          for(let i = 0; i < adMaterialDataNewCreativeArrayLength; i++){
            if(this.adMaterialDataNew.creative_array[i].c_sr_i != '' && this.adMaterialDataNew.creative_array[i].c_sr_i != null && typeof this.adMaterialDataNew.creative_array[i].c_sr_i != 'undefined'){
              let _tmpMaterialContent = JSON.stringify(this.adMaterialDataNew.creative_array[i]);
              let _tmpCreativeArray = this.adMaterialJsonData[this.adMaterialDataNew.creative_array[i].c_sr_i];

              if(_tmpMaterialContent != _tmpCreativeArray){
                console.log('原內容有做修改');
                isChange.push(this.adMaterialDataNew.creative_array[i].c_sr_i);
              } else {
                console.log('原內容沒有修改');
              }

              console.log(_tmpMaterialContent);
              console.log(this.adMaterialJsonData[this.adMaterialDataNew.creative_array[i].c_sr_i]);
            } else {
              console.log('新建');
            }
          }
        }

        console.log('isChange');
        console.log(isChange);

        console.log('this.adMaterialDataNew');
        console.log(this.adMaterialDataNew);

        console.log('this.adMaterialJsonData');
        console.log(this.adMaterialJsonData);

        console.log('3 error');
        console.log(error);

        console.log('this.showLang');
        console.log(this.showLang);
        console.log('#1 this.selectLang');
        console.log(this.selectLang);        
        console.log("this.showLang[this.selectLang]['views']['EventBrowse']");
        console.log(this.showLang[this.selectLang]['views']['EventBrowse']);        

        if(error == 0){
          let member_hash = this.$route.params.id
          let adaccount_id = this.$route.params.adaccount_id

          console.log('#2 this.selectLang');
          console.log(this.selectLang); 

          let _tmp_showLang = this.showLang
          let _tmp_selectLang = this.selectLang

          axios
            .post('https://test.autoturn.net/inside/api/campaign_member_status.php', Qs.stringify({
              s_code: member_hash,
              route_type: this.$route.params.type,
              active: 'member',
            }))
            .then((caResponse) => {
              console.log('#3 this.selectLang');
              console.log(this.selectLang); 

              if(caResponse.data.status == 'error'){
                if(caResponse.data.type == 2){
                  Swal.fire({
                    icon: caResponse.data.status,
                    title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['error']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['error']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                    }
                  })
                } else if(caResponse.data.type == 3){
                  Swal.fire({
                    icon: caResponse.data.status,
                    title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['error']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['error']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/t/"+member_hash;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/t/"+member_hash;
                    }
                  })
                } else {
                  Swal.fire(
                            this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['error']['swal_title'],
                            caResponse.data.info,
                            caResponse.data.status
                          )
                }
              }

              if(caResponse.data.status == 'warning'){
                Swal.fire({
                  icon: 'warning',
                  title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  let formData = {
                    campaign_id: this.campaign_id,
                    adaccount_id: this.adaccount_id,
                    idData: this.idData,
                    regionsData: this.regionsData,
                    goalsData: this.goalsData,
                    isChangeDataMaterial: this.isChangeDataMaterial,
                    postData: this.postData,
                    isChangeDataAdMaterial: this.isChangeDataAdMaterial,
                    isChange: isChange,
                    adMaterialData: this.adMaterialDataNew
                  }

                  let member_hash = this.$route.params.id
                  let adaccount_id = this.adaccount_id
                  let campaign_id = this.campaign_id

                  console.log('warning this.isChangeDataMaterial');
                  console.log(this.isChangeDataMaterial);
                  console.log('this.isChangeDataAdMaterial');
                  console.log(this.isChangeDataAdMaterial);

                  axios
                    .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_browse_update.php', Qs.stringify({
                      s_code: member_hash,
                      form_data: formData,
                    }))
                    .then((response) => {
                      // console.log(response.data);
                      if(response.data.status == 'success'){
                        if(this.isChangeDataMaterial == true){
                          //post_task
                          console.log('post_task');
                          if(response.data.post_task != '' && response.data.post_task != null && typeof(response.data.post_task) != 'undefined'){
                            var status = 1;
                            this.releaseType = true
                            this.style = 'z-index:100;';
                            console.log('releaseType');
                            var bar5 = new ldBar("#myItem5");
                            bar5.set(this.releasePercent);
                            setInterval( () => {
                                if(status == 1){
                                  console.log('status');
                                  console.log(status);
                                  axios
                                    .post('https://test.autoturn.net/inside/api/campaign_task.php', Qs.stringify({
                                      s_code: member_hash,
                                      id: response.data.post_task,
                                    }))
                                    .then((taskResponse) => {
                                      // console.log('post_task');
                                      // console.log(taskResponse.data);
                                      if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'FAILURE'){
                                        status = 0;
                                        Swal.fire({
                                          icon: 'error',
                                          title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_failure']['swal_title'],
                                          text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_failure']['swal_text']+taskResponse.data.return_data.current,
                                          showDenyButton: false,
                                          showCancelButton: false,
                                          confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_failure']['confirm_button'],
                                          // timer: 5000
                                          // denyButtonText: `Don't save`,
                                        }).then((result) => {
                                          this.releaseType = false
                                          this.style = 'z-index:-1;';
                                          this.releasePercent = 5;
                                          /* Read more about isConfirmed, isDenied below */
                                          // if (result.isConfirmed) {
                                          //   // Swal.fire('Saved!', '', 'success')
                                          //   this.showCampaignData = true
                                          //   window.location.href = "https://dev-private.autoturn.net/event-browse/t/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                          // } else if (result.isDenied) {
                                          //   // Swal.fire('Changes are not saved', '', 'info')
                                          //   this.showCampaignData = true
                                          //   window.location.href = "https://dev-private.autoturn.net/event-browse/t/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                          // }

                                          // if (result.dismiss === Swal.DismissReason.timer) {
                                          //   this.showCampaignData = true
                                          //   window.location.href = "https://dev-private.autoturn.net/event-browse/t/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                          // }
                                        })
                                      } else if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'SUCCESS'){
                                        status = 0;
                                        axios
                                          .post('https://test.autoturn.net/inside/api/data/campaign_view_creatives_update.php', Qs.stringify({
                                            s_code: member_hash,
                                            id: campaign_id,
                                          }))
                                          .then((response) => {
                                            Swal.fire({
                                              icon: 'success',
                                              title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_success']['swal_title'],
                                              text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_success']['swal_text'],
                                              title: '確認修改',/*
                                              text: '修改完成，5秒後將為您導回列表頁。',*/
                                              showDenyButton: false,
                                              showCancelButton: false,
                                              confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_success']['confirm_button'],
                                              // confirmButtonText: '確定',
                                              timer: 5000
                                              // denyButtonText: `Don't save`,
                                            }).then((result) => {
                                              /* Read more about isConfirmed, isDenied below */
                                              if (result.isConfirmed) {
                                                // Swal.fire('Saved!', '', 'success')
                                                this.showCampaignData = true
                                                window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                              } else if (result.isDenied) {
                                                // Swal.fire('Changes are not saved', '', 'info')
                                                this.showCampaignData = true
                                                window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                              }

                                              if (result.dismiss === Swal.DismissReason.timer) {
                                                this.showCampaignData = true
                                                window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                              }
                                            })
                                          });
                                      } else {
                                        this.releasePercent = taskResponse.data.return_data.pct

                                        bar5.set(this.releasePercent);

                                        if(taskResponse.data.return_data.pct == 100){
                                          this.releaseType = false
                                          this.style = 'z-index:-1;';
                                          this.releasePercent = 5;
                                          status = 0;
                                        }
                                      }

                                      // console.log('taskResponse.data.return_data.state:'+taskResponse.data.return_data.state);
                                      // console.log('taskResponse.data.return_data.current:'+taskResponse.data.return_data.current);
                                      // console.log('taskResponse.data.return_data.pct:'+taskResponse.data.return_data.pct);
                                      // console.log('taskResponse.data.return_data.info_state:'+taskResponse.data.return_data.info_state);
                                    });
                                }
                              }, 3000);
                          }

                        } else if(this.isChangeDataAdMaterial == true){
                          //creatives_task
                          console.log('creatives_task');
                          if(response.data.creatives_task != '' && response.data.creatives_task != null && typeof(response.data.creatives_task) != 'undefined'){
                            var status = 1;
                            this.releaseType = true
                            this.style = 'z-index:100;';
                            console.log('releaseType');
                            var bar5 = new ldBar("#myItem5");
                            bar5.set(this.releasePercent);
                            setInterval( () => {
                                if(status == 1){
                                  console.log('status');
                                  console.log(status);
                                  axios
                                    .post('https://test.autoturn.net/inside/api/campaign_task.php', Qs.stringify({
                                      s_code: member_hash,
                                      id: response.data.creatives_task,
                                    }))
                                    .then((taskResponse) => {
                                      // console.log('creatives_task');
                                      // console.log(taskResponse.data);
                                      if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'FAILURE'){
                                        status = 0;
                                        Swal.fire({
                                          icon: 'error',
                                          title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['ad_material']['info_state_failure']['swal_title'],
                                          text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['ad_material']['info_state_failure']['swal_text']+taskResponse.data.return_data.current,
                                          showDenyButton: false,
                                          showCancelButton: false,
                                          confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['ad_material']['info_state_failure']['confirm_button'],
                                          // timer: 5000
                                          // denyButtonText: `Don't save`,
                                        }).then((result) => {
                                          this.releaseType = false
                                          this.style = 'z-index:-1;';
                                          this.releasePercent = 5;
                                          /* Read more about isConfirmed, isDenied below */
                                          // if (result.isConfirmed) {
                                          //   // Swal.fire('Saved!', '', 'success')
                                          //   this.showCampaignData = true
                                          //   window.location.href = "https://dev-private.autoturn.net/event-browse/t/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                          // } else if (result.isDenied) {
                                          //   // Swal.fire('Changes are not saved', '', 'info')
                                          //   this.showCampaignData = true
                                          //   window.location.href = "https://dev-private.autoturn.net/event-browse/t/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                          // }

                                          // if (result.dismiss === Swal.DismissReason.timer) {
                                          //   this.showCampaignData = true
                                          //   window.location.href = "https://dev-private.autoturn.net/event-browse/t/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                          // }
                                        })
                                      } else if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'SUCCESS'){
                                        status = 0;
                                        Swal.fire({
                                          icon: 'success',
                                          title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['ad_material']['info_state_success']['swal_title'],
                                          text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['ad_material']['info_state_success']['swal_text'],
                                          // title: '確認修改',
                                          // text: '修改完成，5秒後將為您導回列表頁。',
                                          showDenyButton: false,
                                          showCancelButton: false,
                                          confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['ad_material']['info_state_success']['confirm_button'],
                                          // confirmButtonText: '確定',
                                          timer: 5000
                                          // denyButtonText: `Don't save`,
                                        }).then((result) => {
                                          /* Read more about isConfirmed, isDenied below */
                                          if (result.isConfirmed) {
                                            // Swal.fire('Saved!', '', 'success')
                                            this.showCampaignData = true
                                            window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                          } else if (result.isDenied) {
                                            // Swal.fire('Changes are not saved', '', 'info')
                                            this.showCampaignData = true
                                            window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                          }

                                          if (result.dismiss === Swal.DismissReason.timer) {
                                            this.showCampaignData = true
                                            window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                          }
                                        })
                                      } else {
                                        this.releasePercent = taskResponse.data.return_data.pct

                                        bar5.set(this.releasePercent);

                                        if(taskResponse.data.return_data.pct == 100){
                                          this.releaseType = false
                                          this.style = 'z-index:-1;';
                                          this.releasePercent = 5;
                                          status = 0;
                                        }
                                      }

                                      // console.log('taskResponse.data.return_data.state:'+taskResponse.data.return_data.state);
                                      // console.log('taskResponse.data.return_data.current:'+taskResponse.data.return_data.current);
                                      // console.log('taskResponse.data.return_data.pct:'+taskResponse.data.return_data.pct);
                                      // console.log('taskResponse.data.return_data.info_state:'+taskResponse.data.return_data.info_state);
                                    });
                                }
                              }, 3000);
                          }
                        } else {
                          Swal.fire({
                            icon: 'success',
                            title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['not_material']['swal_title'],
                            text: response.data.info,
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['not_material']['confirm_button'],
                            // denyButtonText: `Don't save`,
                          }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            // if (result.isConfirmed) {
                              // Swal.fire('Saved!', '', 'success')

                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                            // } else if (result.isDenied) {
                              // Swal.fire('Changes are not saved', '', 'info')
                            // }
                          })
                        }

                        // this.immediateList = response.data.return_data
                        // this.formData = response.data.return_data.form

                        // if(type == 1){
                        //   var todayForm = new Date();
                        //   var yearForm = todayForm.getFullYear();
                        //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                        //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                        //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                        //   todayForm = yearForm + monthForm + dateForm + timeForm;

                        //   this.formTitle = 'title_'+todayForm;
                        // } else {
                        //   this.formTitle = response.data.return_data.name;
                        // }

                        // this.showModal = true
                      } else {
                        let text = this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['update_not_success_default_swal_text'];
                        if(response.data.info != '' && response.data.info != null){
                          text = response.data.info
                        }
                        Swal.fire(
                          this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['update_not_success_swal_title'],
                          'error'
                        )
                      }
                    });
                });
              }

              if(caResponse.data.status == 'success'){
                console.log('#4 this.selectLang');
                console.log(this.selectLang); 

                let formData = {
                  campaign_id: this.campaign_id,
                  adaccount_id: this.adaccount_id,
                  idData: this.idData,
                  regionsData: this.regionsData,
                  goalsData: this.goalsData,
                  isChangeDataMaterial: this.isChangeDataMaterial,
                  postData: this.postData,
                  isChangeDataAdMaterial: this.isChangeDataAdMaterial,
                  isChange: isChange,
                  adMaterialData: this.adMaterialDataNew
                }

                let member_hash = this.$route.params.id
                let adaccount_id = this.adaccount_id
                let campaign_id = this.campaign_id

                console.log('success this.isChangeDataMaterial');
                console.log(this.isChangeDataMaterial);
                console.log('this.isChangeDataAdMaterial');
                console.log(this.isChangeDataAdMaterial);

                axios
                  .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_browse_update.php', Qs.stringify({
                    s_code: member_hash,
                    form_data: formData,
                  }))
                  .then((response) => {
                    // console.log(response.data);
                    console.log('#5 this.selectLang');
                    console.log(this.selectLang); 

                    if(response.data.status == 'success'){
                      if(this.isChangeDataMaterial == true){
                        //post_task
                        console.log('post_task');
                        console.log('#6 this.selectLang');
                        console.log(this.selectLang); 
                        if(response.data.post_task != '' && response.data.post_task != null && typeof(response.data.post_task) != 'undefined'){
                          var status = 1;
                          this.releaseType = true;
                          this.style = 'z-index:100;';
                          console.log('releaseType');
                          console.log(this.releaseType);
                          var bar5 = new ldBar("#myItem5");
                          bar5.set(this.releasePercent);
                          setInterval( () => {
                              if(status == 1){
                                console.log(status);
                                console.log('#7 this.selectLang');
                                console.log(this.selectLang); 
                                console.log('#7 _tmp_showLang');
                                console.log(_tmp_showLang); 
                                axios
                                  .post('https://test.autoturn.net/inside/api/campaign_task.php', Qs.stringify({
                                    s_code: member_hash,
                                    id: response.data.post_task,
                                  }))
                                  .then((taskResponse) => {
                                    console.log('#8 this.selectLang');
                                    console.log(this.selectLang); 
                                    console.log('#8 _tmp_showLang');
                                    console.log(_tmp_showLang); 
                                    // console.log('post_task');
                                    // console.log(taskResponse.data);
                                    if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'FAILURE'){
                                      status = 0;
                                      this.releaseType = false;
                                      this.style = 'z-index:-1;';
                                      this.releasePercent = 5;
                                      console.log('完成但出錯');
                                      console.log('releaseType');
                                      console.log(this.releaseType);
                                      Swal.fire({
                                        icon: 'error',
                                        title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['material']['info_state_failure']['swal_title'],
                                        text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['material']['info_state_failure']['swal_text']+taskResponse.data.return_data.current,
                                        showDenyButton: false,
                                        showCancelButton: false,
                                        confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['material']['info_state_failure']['confirm_button'],
                                        // timer: 5000
                                        // denyButtonText: `Don't save`,
                                      }).then((result) => {                                        
                                        /* Read more about isConfirmed, isDenied below */
                                        // if (result.isConfirmed) {
                                        //   // Swal.fire('Saved!', '', 'success')
                                        //   this.showCampaignData = true
                                        //   window.location.href = "https://dev-private.autoturn.net/event-browse/t/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                        // } else if (result.isDenied) {
                                        //   // Swal.fire('Changes are not saved', '', 'info')
                                        //   this.showCampaignData = true
                                        //   window.location.href = "https://dev-private.autoturn.net/event-browse/t/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                        // }

                                        // if (result.dismiss === Swal.DismissReason.timer) {
                                        //   this.showCampaignData = true
                                        //   window.location.href = "https://dev-private.autoturn.net/event-browse/t/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                        // }
                                      })
                                    } else if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'SUCCESS'){
                                      status = 0;
                                      axios
                                        .post('https://test.autoturn.net/inside/api/data/campaign_view_creatives_update.php', Qs.stringify({
                                          s_code: member_hash,
                                          id: campaign_id,
                                        }))
                                        .then((response) => {
                                          Swal.fire({
                                            icon: 'success',
                                            title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['material']['info_state_success']['swal_title'],
                                            text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['material']['info_state_success']['swal_text'],
                                            // title: '確認修改',
                                            // text: '修改完成，5秒後將為您導回列表頁。',
                                            showDenyButton: false,
                                            showCancelButton: false,
                                            confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['material']['info_state_success']['confirm_button'],
                                            // confirmButtonText: '確定',
                                            timer: 5000
                                            // denyButtonText: `Don't save`,
                                          }).then((result) => {
                                            /* Read more about isConfirmed, isDenied below */
                                            if (result.isConfirmed) {
                                              // Swal.fire('Saved!', '', 'success')
                                              this.showCampaignData = true
                                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                            } else if (result.isDenied) {
                                              // Swal.fire('Changes are not saved', '', 'info')
                                              this.showCampaignData = true
                                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                            }

                                            if (result.dismiss === Swal.DismissReason.timer) {
                                              this.showCampaignData = true
                                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                            }
                                          })
                                        });
                                    } else {
                                      this.releasePercent = taskResponse.data.return_data.pct

                                      bar5.set(this.releasePercent);

                                      if(taskResponse.data.return_data.pct == 100){
                                        this.releaseType = false
                                        this.style = 'z-index:-1;';
                                        this.releasePercent = 5;
                                        status = 0;
                                      }
                                    }

                                    // console.log('taskResponse.data.return_data.state:'+taskResponse.data.return_data.state);
                                    // console.log('taskResponse.data.return_data.current:'+taskResponse.data.return_data.current);
                                    // console.log('taskResponse.data.return_data.pct:'+taskResponse.data.return_data.pct);
                                    // console.log('taskResponse.data.return_data.info_state:'+taskResponse.data.return_data.info_state);
                                  });
                              }
                            }, 3000);
                        }

                      } else if(this.isChangeDataAdMaterial == true){
                        //creatives_task
                        console.log('creatives_task');
                        if(response.data.creatives_task != '' && response.data.creatives_task != null && typeof(response.data.creatives_task) != 'undefined'){
                          var status = 1;
                          this.releaseType = true
                          this.style = 'z-index:100;';
                          console.log('releaseType');
                          var bar5 = new ldBar("#myItem5");
                          bar5.set(this.releasePercent);
                          setInterval( () => {
                              if(status == 1){
                                console.log('status');
                                console.log(status);
                                axios
                                  .post('https://test.autoturn.net/inside/api/campaign_task.php', Qs.stringify({
                                    s_code: member_hash,
                                    id: response.data.creatives_task,
                                  }))
                                  .then((taskResponse) => {
                                    // console.log('creatives_task');
                                    // console.log(taskResponse.data);
                                    if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'FAILURE'){
                                      status = 0;
                                      Swal.fire({
                                        icon: 'error',
                                        title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['ad_material']['info_state_failure']['swal_title'],
                                        text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['ad_material']['info_state_failure']['swal_text']+taskResponse.data.return_data.current,
                                        showDenyButton: false,
                                        showCancelButton: false,
                                        confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['ad_material']['info_state_failure']['confirm_button'],
                                        // timer: 5000
                                        // denyButtonText: `Don't save`,
                                      }).then((result) => {
                                        this.releaseType = false
                                        this.style = 'z-index:-1;';
                                        this.releasePercent = 5;
                                        /* Read more about isConfirmed, isDenied below */
                                        // if (result.isConfirmed) {
                                        //   // Swal.fire('Saved!', '', 'success')
                                        //   this.showCampaignData = true
                                        //   window.location.href = "https://dev-private.autoturn.net/event-browse/t/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                        // } else if (result.isDenied) {
                                        //   // Swal.fire('Changes are not saved', '', 'info')
                                        //   this.showCampaignData = true
                                        //   window.location.href = "https://dev-private.autoturn.net/event-browse/t/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                        // }

                                        // if (result.dismiss === Swal.DismissReason.timer) {
                                        //   this.showCampaignData = true
                                        //   window.location.href = "https://dev-private.autoturn.net/event-browse/t/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                        // }
                                      })
                                    } else if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'SUCCESS'){
                                      status = 0;
                                      Swal.fire({
                                        icon: 'success',
                                        title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['ad_material']['info_state_success']['swal_title'],
                                        text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['ad_material']['info_state_success']['swal_text'],
                                        // title: '確認修改',
                                        // text: '修改完成，5秒後將為您導回列表頁。',
                                        showDenyButton: false,
                                        showCancelButton: false,
                                        confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['ad_material']['info_state_success']['confirm_button'],
                                        // confirmButtonText: '確定',
                                        timer: 5000
                                        // denyButtonText: `Don't save`,
                                      }).then((result) => {
                                        /* Read more about isConfirmed, isDenied below */
                                        if (result.isConfirmed) {
                                          // Swal.fire('Saved!', '', 'success')
                                          this.showCampaignData = true
                                          window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                        } else if (result.isDenied) {
                                          // Swal.fire('Changes are not saved', '', 'info')
                                          this.showCampaignData = true
                                          window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                        }

                                        if (result.dismiss === Swal.DismissReason.timer) {
                                          this.showCampaignData = true
                                          window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                        }
                                      })
                                    } else {
                                      this.releasePercent = taskResponse.data.return_data.pct

                                      bar5.set(this.releasePercent);

                                      if(taskResponse.data.return_data.pct == 100){
                                        this.releaseType = false
                                        this.style = 'z-index:-1;';
                                        this.releasePercent = 5;
                                        status = 0;
                                      }
                                    }

                                    // console.log('taskResponse.data.return_data.state:'+taskResponse.data.return_data.state);
                                    // console.log('taskResponse.data.return_data.current:'+taskResponse.data.return_data.current);
                                    // console.log('taskResponse.data.return_data.pct:'+taskResponse.data.return_data.pct);
                                    // console.log('taskResponse.data.return_data.info_state:'+taskResponse.data.return_data.info_state);
                                  });
                              }
                            }, 3000);
                        }
                      } else {
                        Swal.fire({
                          icon: 'success',
                          title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['not_material']['swal_title'],
                          text: response.data.info,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['not_material']['confirm_button'],
                          // denyButtonText: `Don't save`,
                        }).then((result) => {
                          /* Read more about isConfirmed, isDenied below */
                          // if (result.isConfirmed) {
                            // Swal.fire('Saved!', '', 'success')

                            window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                          // } else if (result.isDenied) {
                            // Swal.fire('Changes are not saved', '', 'info')
                          // }
                        })
                      }

                      // this.immediateList = response.data.return_data
                      // this.formData = response.data.return_data.form

                      // if(type == 1){
                      //   var todayForm = new Date();
                      //   var yearForm = todayForm.getFullYear();
                      //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                      //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                      //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                      //   todayForm = yearForm + monthForm + dateForm + timeForm;

                      //   this.formTitle = 'title_'+todayForm;
                      // } else {
                      //   this.formTitle = response.data.return_data.name;
                      // }

                      // this.showModal = true
                    } else {
                      let text = this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['update_not_success_default_swal_text'];
                      if(response.data.info != '' && response.data.info != null){
                        text = response.data.info
                      }
                      Swal.fire(
                        this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['success']['campaign_browse_update']['update_not_success_swal_title'],
                        text,
                        'error'
                      )
                    }
                  });
              }

              if(caResponse.data.status == 'login'){
                Swal.fire({
                  icon: 'error',
                  title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['login']['swal_title'],
                  text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['login']['swal_text'],
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['login']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    // Swal.fire('Saved!', '', 'success')
                    // this.allPageLoading = true
                    window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                  } else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    // this.allPageLoading = true
                    window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                  }
                })
              }
            });
        }
      }
    },
    mounted () {
      // document.title = '行銷活動瀏覽/編輯頁 - AutoTurn';
    }
  }
</script>

<style lang="scss" scope>
  .progressbar {
    background: linear-gradient(270.01deg, #1D619F 0%, #7FDCFA 51.04%, #7AD5C0 76.56%);
    border-radius: 6px;
  }
</style>